import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#00624a',
                secondary: '#0053a0',
                accent: '#616161',
                error: '#ff5722',
            },
        },
    },
});
